import React from 'react';
import ApplyCta from './ApplyCta';
import FrostedCardHeroLayout from './hero/FrostedCardHeroLayout';

/**
 * Hero (Home Page Hero)
 * Layout / Design: ABOUT HERO DESIGN (Frosted Card Layout with full-bleed atmospheric background)
 * Content / Data: HOME HERO CONTENT (Home headings, narrative, CTAs, links)
 */
export default function Hero() {
  return (
    <FrostedCardHeroLayout
      id="home"
      backgroundImage="/home.webp"
      backgroundAlt="InnovHer Home - Ecosystem of Builders"
      badge={
        <div className="reveal-up inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/10 bg-white/[0.04] backdrop-blur text-xs font-medium tracking-[0.2em] text-[#ff8ec5] uppercase">
          <span className="w-2 h-2 rounded-full bg-[#d42b92] animate-pulse" />
          <span>InnovHer · Venture Builders</span>
        </div>
      }
    >
      {/* Home Hero Heading */}
      <h1 className="font-semibold tracking-[-0.035em] text-white leading-[1.08] text-3xl sm:text-4xl md:text-5xl lg:text-[44px]">
        Where ambition{' '}
        <span className="block mt-1 sm:inline sm:mt-0">
          becomes <span className="text-[#d42b92] italic">enterprise</span>.
        </span>
      </h1>

      {/* Home Hero Lead */}
      <p className="mt-6 text-lg sm:text-xl text-white/90 leading-snug">
        <span className="text-[#ff8ec5] font-semibold">InnovHer</span>, an ecosystem built for ideas with the ambition to become more.
      </p>

      {/* Home Hero Narrative Body */}
      <div className="mt-6 space-y-4 text-white/70 text-sm sm:text-base lg:text-[17px] leading-relaxed">
        <p>
          InnovHer is a venture-building platform bringing together strategy, technology, capital, capability and connections to transform possibilities into enterprises of consequence. From shaping an early idea to accelerating an evolving venture, the ecosystem enables founders and businesses to build, strengthen and scale what comes next.
        </p>
        <p className="text-white/50 text-xs sm:text-sm">
          Built in India with an outlook beyond boundaries, InnovHer brings together entrepreneurial ambition and the infrastructure to act on it.
        </p>
        <div className="pt-2">
          <p className="text-white font-semibold text-lg sm:text-xl">
            Because possibilities matter.
          </p>
          <p className="text-[#ff8ec5] font-semibold text-lg sm:text-xl italic">
            And what we build from them matters more!!
          </p>
        </div>
      </div>

      {/* Home Hero CTAs & Destinations */}
      {/* <div className="mt-8 pt-2 flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3">
        <ApplyCta to="/apply" label="Apply to InnovAce" size="md" />
        <ApplyCta to="/contact" label="Contact Us" size="md" variant="secondary" />
        <a
          href="#ventures"
          data-cursor="hover"
          className="px-6 py-3 rounded-full text-white/90 border border-white/15 hover:border-[#d42b92] hover:text-[#d42b92] transition-colors text-xs sm:text-sm font-medium"
        >
          What We&rsquo;re Building
        </a>
      </div> */}
    </FrostedCardHeroLayout>
  );
}
